// extracted by mini-css-extract-plugin
module.exports = {"menuElementResponsive":"_1Gc_MMMgzVgQHLyLoCImlG","menuElementTooltip":"_2j2CIUiEJXh1lohfsQ-TNG","menuElement":"_1R8AO6D3fIsEuPLXtVkO2a"};